import { useIntl } from 'react-intl';
import { Col, Input, Row } from 'antd';

import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';

import OrderExtraFilter from '@/components/_common/ExtraFilters/OrderExtraFilter';
import ActiveExtraFilter from '@/components/_common/ExtraFilters/ActiveExtraFilter';
import { ListSuppliersQuery } from '@/core/domain/people/Suppliers/Suppliers.types';

function SupplierExtraFilters({
  queryParams,
  setQueryParams,
}: ExtraFiltersProps<ListSuppliersQuery>) {
  const intl = useIntl();

  return (
    <Row gutter={[16, 16]}>
      <Col lg={8} span={24}>
        <Input
          value={queryParams?.cpfCnpj}
          onChange={({ target: { value } }) =>
            setQueryParams((prev) => ({ ...prev, cpfCnpj: value }))
          }
          placeholder={intl.formatMessage({
            id: 'suppliers.filters.cpfCnpj',
          })}
        />
      </Col>

      <Col md={12} lg={8} span={24}>
        <Input
          value={queryParams?.product}
          onChange={({ target: { value } }) =>
            setQueryParams((prev) => ({ ...prev, product: value }))
          }
          placeholder={intl.formatMessage({
            id: 'suppliers.general.form.product',
          })}
        />
      </Col>

      <Col md={12} lg={8} span={24}>
        <Input
          value={queryParams?.nickName}
          onChange={({ target: { value } }) =>
            setQueryParams((prev) => ({ ...prev, nickName: value }))
          }
          placeholder={intl.formatMessage({
            id: 'suppliers.filters.nickName',
          })}
        />
      </Col>

      <Col span={24} md={12} lg={4}>
        <OrderExtraFilter
          value={queryParams?.order}
          onChange={(value) =>
            setQueryParams((prev) => ({
              ...prev,
              order: value,
            }))
          }
        />
      </Col>

      <Col span={24} md={12} lg={4}>
        <ActiveExtraFilter
          value={queryParams?.active}
          onChange={(value) =>
            setQueryParams((prev) => ({
              ...prev,
              active: value as unknown as boolean,
            }))
          }
        />
      </Col>
    </Row>
  );
}

export default SupplierExtraFilters;
